// @ts-nocheck

import {RichTextEditor as RTE_Lib, RTE_TOOLBAR_CLASS} from "../../../main/index.js";
import tippy, {createSingletonWrapper} from "./tippy-control.js";

class RichTextEditor extends RTE_Lib {
	constructor(params) {
		const {
			// Data
			autofocus,
			blurOnEnter,
			constructEditorImmediately,
			content,
			editable,
			enabledExtensions,
			limit,
			placeholder,
			preserveWhitespaceFull,
			showToolbarOnFocusOnly,

			// Callbacks
			onBlur,
			onFocus,
			onKeyDownEnter,
			onUpdate,

			id,
			wrapper
		} = params;

		const element = wrapper.querySelector(`.js-rte-${id}`);

		super({
			autofocus,
			blurOnEnter,
			constructEditorImmediately,
			content,
			editable,
			element,
			enabledExtensions,
			limit,
			placeholder,
			preserveWhitespaceFull,
			showToolbarOnFocusOnly
		}, {
			onBlur,
			onFocus,
			onKeyDownEnter,
			onSetUpToolbar: () => {
				const tippyInstances = tippy(wrapper.querySelectorAll(`.${RTE_TOOLBAR_CLASS} [data-tooltip-text]`), {
					content: (reference) => reference.getAttribute("data-tooltip-text")
				});
				createSingletonWrapper(tippyInstances, {
					placement: "bottom"
				});
			},
			onUpdate
		});
	}
}

export default RichTextEditor;
